import { motion } from "framer-motion";
import { Instagram as IgIcon } from "lucide-react";
import { SectionHeading } from "./Reveal";
import { INSTAGRAM_TILES, CONTACT } from "../../data/content";

export const Instagram = () => (
    <section id="instagram" data-testid="instagram-section" className="bg-ivory py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <SectionHeading eyebrow="Follow Along" title="Life Behind the Florals" script={CONTACT.instagram} />

            <div className="mt-14 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
                {INSTAGRAM_TILES.map((src, i) => (
                    <motion.a
                        key={src}
                        href={CONTACT.instagramUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`instagram-tile-${i}`}
                        initial={{ opacity: 0, scale: 0.94 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true, margin: "-40px" }}
                        transition={{ duration: 0.6, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] }}
                        className="group relative block aspect-square overflow-hidden border border-gold/30"
                        aria-label={`Instagram post ${i + 1}`}
                    >
                        <img
                            src={src}
                            alt={`Events by Leemerh Instagram ${i + 1}`}
                            loading="lazy"
                            className="h-full w-full object-cover transition-transform duration-[1100ms] ease-elegant group-hover:scale-110"
                        />
                        <span className="absolute inset-0 flex items-center justify-center bg-emerald/0 transition-colors duration-500 group-hover:bg-emerald/55">
                            <IgIcon className="text-gold opacity-0 transition-[opacity,transform] duration-500 group-hover:scale-110 group-hover:opacity-100" size={26} />
                        </span>
                    </motion.a>
                ))}
            </div>

            <motion.p
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
                className="mt-10 text-center text-sm text-emerald-light/75"
            >
                Daily inspiration, behind-the-scenes styling and fresh celebrations —{" "}
                <a
                    href={CONTACT.instagramUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="instagram-follow-link"
                    className="font-semibold text-gold-soft underline decoration-gold/40 underline-offset-4 transition-colors duration-300 hover:text-gold"
                >
                    follow {CONTACT.instagram}
                </a>
            </motion.p>
        </div>
    </section>
);
